import React, { useEffect, useState } from "react";
import { api } from "../../utils/Api";
import { Link } from "react-router-dom";

export default function AddWorkExperience(props: any) {
  const [form_data, SetFormData] = useState([
    {
      company: "",
      designation: "",
      from: "",
      to: "",
      present: false,
      min_from: "",
      max_from: "",
      min_to: "",
      max_to: "",
    },
  ]);

  async function save() {
    let pass_data = {
      // get: {},
      post: {
        experience_details: form_data,
      },
    };
    console.log("passdata :", pass_data);
    let response = await api("/users/add_experience", pass_data);
    console.log("add_experience response :", response);
  }

  function submitValue(event: any) {
    const frmDetails = form_data;
    console.log(frmDetails);
    event.preventDefault();
    save();
    window.location.href = "/dashboard";
  }

  function addClick() {
    SetFormData((preValue: any) => {
      preValue.push({
        company: "",
        designation: "",
        from: "",
        to: "",
        present: false,
        min_from: "",
        max_from: "",
        min_to: "",
        max_to: "",
      });
      console.log(preValue);
      return [...preValue];
    });
  }

  function removeClick(i: any) {
    console.log("remove index:", i);
    SetFormData((preValue: any) => {
      preValue.splice(i, 1);
      return [...preValue];
    });
  }

  return (
    <div className="pt-3">
      <div
        className={
          !props.hasOwnProperty("from") && props.from != "create_account"
            ? "container"
            : ""
        }
      >
        <div className="row">
          <div
            className={
              !props.hasOwnProperty("from") && props.from != "create_account"
                ? "col-lg-8 mx-auto"
                : "col-12"
            }
          >
            <div className="card p-3">
              <h3>Work Experience</h3>
              <div className="mt-2 basic-list">
                {form_data.map((item, index) => (
                  <div key={index} className="basic-list-item">
                    <div className="mb-3 ">
                      <label
                        for="exampleFormControlInput1"
                        className="form-label"
                      >
                        Company Name{" "}
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlInput1"
                        type="text"
                        placeholder="Your Company Name"
                        value={item.company}
                        onChange={(e) => {
                          SetFormData((preValue) => {
                            preValue[index].company = e.target.value;
                            return [...preValue];
                          });
                        }}
                      />
                    </div>

                    <div className="mb-3 mt-3">
                      <label
                        for="exampleFormControlInput1"
                        className="form-label"
                      >
                        Designation{" "}
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlInput1"
                        type="text"
                        placeholder="Your Designation"
                        value={item.designation}
                        onChange={(e) => {
                          SetFormData((preValue) => {
                            preValue[index].designation = e.target.value;
                            return [...preValue];
                          });
                        }}
                      />{" "}
                    </div>

                    <div className="row">
                      <div className="col-sm">
                        <div className="mb-3">
                          <label
                            htmlFor="from"
                            for="exampleFormControlInput1"
                            className="form-label"
                          >
                            From
                          </label>{" "}
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            type="date"
                            placeholder="From"
                            value={item.from}
                            min={item.min_from}
                            max={item.max_from}
                            onChange={(e) => {
                              SetFormData((preValue) => {
                                // preValue[index].from = e.target.value;
                                var date1 = new Date(preValue[index].to);
                                var date2 = new Date(e.target.value);

                                if (date1 < date2) {
                                  // alert("From date is greater than To Date");
                                } else {
                                  preValue[index].from = e.target.value;
                                }

                                preValue[index].min_to = e.target.value;

                                console.log(
                                  "date1from.getTime() :",
                                  date1.getTime()
                                );
                                console.log(
                                  "date2from.getTime() :",
                                  date2.getTime()
                                );
                                return [...preValue];
                              });
                            }}
                          />
                          {/* {" "} */}
                        </div>
                      </div>
                      <div className="col-sm">
                        {!item.present && (
                          <div className="mb-3">
                            <label
                              htmlFor="To"
                              for="exampleFormControlInput1"
                              className="form-label"
                            >
                              To{" "}
                            </label>{" "}
                            <input
                              className="form-control"
                              id="exampleFormControlInput1"
                              type="date"
                              placeholder="To"
                              value={item.to}
                              min={item.min_to}
                              max={item.max_to}
                              onChange={(e) => {
                                SetFormData((preValue) => {
                                  // preValue[index].to = e.target.value;
                                  var date1 = new Date(preValue[index].from);
                                  var date2 = new Date(e.target.value);

                                  if (date1 < date2) {
                                    preValue[index].to = e.target.value;
                                  } else {
                                    // alert("From date is greater than To Date");
                                  }

                                  preValue[index].max_from = e.target.value;
                                  // preValue[index].min_to = e.target.value;

                                  console.log(
                                    "date1to.getTime() :",
                                    date1.getTime()
                                  );
                                  console.log(
                                    "date2to.getTime() :",
                                    date2.getTime()
                                  );
                                  return [...preValue];
                                });
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ((((((((((((((((((((((((((((((((((((((((((((((to)))))))))))))))))))))))))))))))))))))))))))))) */}

                    {/* _______________Logic Present and To_______________________ */}
                    <div className="mb-3 form-check d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <input
                          className="form-check-input me-3"
                          id="flexCheckDefault"
                          onChange={() => {
                            SetFormData((preValue) => {
                              preValue[index].present =
                                !preValue[index].present;
                              return [...preValue];
                            });
                          }}
                          type="checkbox"
                          checked={item.present}
                        />
                        <label
                          className="form-check-label mt-1"
                          for="flexCheckDefault"
                        >
                          {" "}
                          Present
                        </label>
                      </div>

                      <button
                        type="button"
                        className="btn text-danger text-uppercase fs-12 ms-auto  "
                        onClick={() => removeClick(index)}
                      >
                        <i className="fas fa-trash"></i> <b>Remove</b>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              {/* _______________Add Button_______________________ */}
              <div className="d-grid gap-2 mb3">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={addClick}
                >
                  <i className="fas fa-plus"></i> Add More
                </button>{" "}
              </div>
              <br />

              {/* (((((((((((((((((((((((((((Next button))))))))))))))))))))))))))) */}
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                {props.hasOwnProperty("from") &&
                  props.from == "create_account" && (
                    <div>

                    <button
                      type="button"
                      className="btn btn-primary px-3"
                      onClick={() => {
                        props.on_back();
                      }}
                    >
                      <i className="fas fa-angle-left"></i> Back
                    </button>
                    <button
                    type="button"
                    className="btn btn-primary px-3"
                    onClick={submitValue}
                  >
                    Next <i className="fas fa-angle-right"></i>
                  </button>
                    </div>

                  )}
        
                {!props.hasOwnProperty("from") &&
                  props.from != "create_account" && (
                    <div>
                      
                      <Link className="btn btn-secondary px-3" to="/profile">Back</Link>
                      <button
                      type="button"
                      className="btn btn-primary px-3  ms-2"
                      onClick={submitValue}
                    >
                      Save
                    </button> 
                      
                   
                    </div>
                  )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
